import { authCRUD } from "../../../actions/auth"
import Select from "react-select";
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useEffect, useState } from "react"
import { toast } from "react-toastify"

const userSchema = Yup.object().shape({
  password: Yup.string().min(8, 'Must Contain atleast 8 Characters').required('Password is required'),
  username: Yup.string().required('User name is required'),
  email: Yup.string().email('Wrong email format').min(3, 'Minimum 3 symbols'),
  groups: Yup.array().min(1, 'This field is required')
});

const initialValues = {
  password: '',
  username: '',
  first_name: '',
  last_name: '',
  email: '',
  groups: []
}
export const AddUser = (props) => {

  const {setIndex, index} = props

  const [loading, setLoading] = useState(false)
  const [group, setGroup] = useState([])

  useEffect(() => {
    setTimeout(() => {
      authCRUD.loadUserGroups().then((resp) => {
        setGroup(resp.data)
      })
    }, 2000)
  }, [])

  const formik = useFormik({
    initialValues,
    validationSchema: userSchema,
    onSubmit: (values, { setSubmitting, resetForm  }) => {
      const { password, username, first_name, last_name, email, groups } = values
      const data = { password, username, first_name, last_name, email, groups }
      setLoading(true)
      setTimeout(() => {
        authCRUD.addUser(data).then(() => {
          toast.success('New user has been created.', { autoClose: 7000 })
          resetForm()
          setLoading(false)
          setSubmitting(false)
          setIndex(index+1)
        }).catch((error) => {
          toast.error(error.messages, { autoClose: 7000 })
          setLoading(false)
          setSubmitting(false)
        })
      }, 2000)
    }
  })

  const handleRole = (e) => {
    for (var i = 0; i <= e.length; i++) {
      if (e[i]) {
        initialValues.groups.push(e[i].value);
      }
    }
  }


  return (
    <>
      <div className="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="myLargeModalLabel">New User</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <hr/>
            <form onSubmit={formik.handleSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label for="first_name" className="form-label">First Name</label>
                      <input type="text" id="first_name" {...formik.getFieldProps('first_name')} className="form-control" placeholder="First Name" />
                      {formik.touched.first_name && formik.errors.first_name && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.first_name}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label for="last_name" className="form-label">Last Name</label>
                      <input type="text" id="last_name" {...formik.getFieldProps('last_name')} className="form-control" placeholder="Last Name" />
                      {formik.touched.last_name && formik.errors.last_name && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.last_name}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label for="email" className="form-label">Email Address</label>
                      <input type="email" id="email" {...formik.getFieldProps('email')} className="form-control" placeholder="Email Address" />
                      {formik.touched.email && formik.errors.email && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.email}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label for="groups" className="form-label">Roles</label>
                      <Select
                        options={
                          group?.map((dt) => (
                            {value : dt.id, label : dt.name}
                          ))
                        }
                        placeholder="Select Role"
                        onChange={handleRole}
                        isSearchable={true}
                        isMulti={true}
                      />
                      {formik.touched.groups && formik.errors.groups && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.groups}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label for="username" className="form-label">Username</label>
                      <input type="text" id="username" {...formik.getFieldProps('username')} className="form-control" placeholder="Username" />
                      {formik.touched.username && formik.errors.username && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.username}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="mb-3">
                      <label for="password" className="form-label">Password</label>
                      <input type="password" id="password" {...formik.getFieldProps('password')} className="form-control" placeholder="Password" />
                      {formik.touched.password && formik.errors.password && (
                        <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                          <span role='alert' className='text-danger'>{formik.errors.password}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <hr/>
              <div className="modal-footer">
                <a href="javascript:void(0);" className="btn btn-soft-danger fw-medium" data-bs-dismiss="modal"><i className="ri-close-line me-1 align-middle"></i> Close</a>
                <button type='submit' className="btn btn-soft-success" disabled={formik.isSubmitting || !formik.isValid}>
                  {!loading && <span className='indicator-label'><i className="las la-save la-lg"></i>save </span>}
                  {loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )

}